import { ErrorsEnum } from 'src/app/core/services/error.service';
import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {ActionService, TenantState} from '../../../core/services/action.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TenantService} from '../../../core/services/tenant.service';
import { ErrorService } from '../../../core/services/error.service';
import { toExcelFormat } from 'src/app/helpers/format-position';

@Component({
  selector: 'app-setup-finish',
  templateUrl: './setup-finish.component.html',
  styleUrls: ['./setup-finish.component.scss']
})
export class SetupFinishComponent implements OnInit {

  erps;
  selectedErp: string;
  name: string;
  id: string;
  useInternalProducts = false;
  enableEditionProductByHandScanner = false;
  enableIndependentLevels = false;
  internalProductsTooltip = 'Ao marcar a opção, as informações dos produtos não são resgatadas do ERP e sim em uma tela especifica de produtos no quantum. Apenas produtos serão gerenciados pelo quantum, Ordens de venda continuam sendo resgatadas do ERP.';
  pigeonholeTooltip = 'Posições do tipo escaninho podem conter subdivisões identificadas via qr-code. As movimentações relacionadas a essas posições são realizadas via coletor.';
  activatePendingTasksForProducts = true;
  dummyDetails: FormGroup;
  protheusDetails: FormGroup;
  defaultConfig = {
    TZ: 'America/Sao_Paulo',
  }
  permissionsForm = new FormGroup({
    in: new FormControl(false),
    stock: new FormControl(false),
    packing: new FormControl(false),
    out: new FormControl(false)
  });

  featuresForm = new FormGroup({
    relocation: new FormControl(null),
  });
  enablePigeonhole = false;

  constructor(
    private formBuilder: FormBuilder,
    private actionService: ActionService,
    private tenantsService: TenantService,
    private router: Router,
    private errorService: ErrorService) { }

  ngOnInit(): void {
    this.dummyDetails = this.formBuilder.group({
      url: ['', Validators.required],
    });
    this.protheusDetails = this.formBuilder.group({
      url: ['', Validators.required],
    });

    this.tenantsService.get(true).then(tenant => {
      this.selectedErp = tenant.erp;
      this.name = tenant.name;
      this.id = tenant.id;
      this.useInternalProducts = tenant.moduleProducts;
      this.activatePendingTasksForProducts = tenant?.moduleProductsConfig?.productPendingTask;
      this.enableEditionProductByHandScanner = tenant.enableHandScannerCrateEdition;
      this.enableIndependentLevels = tenant.independentLevels;
      this.permissionsForm.setValue(tenant.process);
      this.featuresForm.setValue(tenant.features);
      this.enablePigeonhole = tenant.enablePigeonhole;
      if(tenant.erp === 'DUMMY'){
        this.dummyDetails.controls.url.patchValue(tenant.erpConfig.url);
      }
      else if(tenant.erp === 'PROTHEUS'){
        this.protheusDetails.controls.url.patchValue(tenant.erpConfig.url);
      }
    });
    this.tenantsService.getErps().then((erps: any) => {
      this.erps = erps;
    });

  }
  async changeErp($event){
    this.selectedErp = $event;
    await this.actionService.setTenantErp({erp: $event});
  }

  async finish(){
    try{
      let config = {};
      if(this.selectedErp === 'DUMMY') {
        if (this.dummyDetails.valid) {
          this.dummyDetails.markAllAsTouched();
          config = this.dummyDetails.getRawValue();
          config = Object.assign(config, this.defaultConfig);
        } else{
          throw new Error('aaa');
        }
      }
      else if(this.selectedErp === 'PROTHEUS') {
        if (this.protheusDetails.valid) {
          this.protheusDetails.markAllAsTouched();
          config = this.protheusDetails.getRawValue();
          config = Object.assign(config, this.defaultConfig);
        } else{
          throw new Error('aaa');
        }
      }

      await this.actionService.setTenantErpConfig({erp: this.selectedErp, config});
      await this.actionService.setTenantState({state: TenantState.ONLINE});
      await this.actionService.setTenantModules({ products: this.useInternalProducts });
      await this.actionService.setTenantConfig({ enableHandScannerCrateEdition: this.enableEditionProductByHandScanner });
      await this.actionService.setTenantProcess({process: this.permissionsForm.value});
      await this.actionService.setTenantIndependentLevels( { independentLevels: this.enableIndependentLevels });
      await this.actionService.setTenantFeatures({ features: this.featuresForm.value });
      await this.actionService.setTenantPigeonhole({ enablePigeonhole: this.enablePigeonhole });
      if (this.useInternalProducts) {
        const moduleProductsConfig = this.activatePendingTasksForProducts ? { productPendingTask: true } : { productPendingTask: false };
        await this.actionService.setModuleProductsConfig(moduleProductsConfig);
      }
      await this.router.navigate(['/setup']);
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
      switch (e.error.type) {
        case ErrorsEnum.TENANT_INDEPENDENT_LEVELS:
          const positionList = e.error.data.map(pos => pos.alias ? pos.alias : `Coordenada: ${toExcelFormat(pos.x, pos.y)}`).join(', ');
          const message = `Para desativar a função, defina um mesmo tipo de nível para as seguintes posições: ${positionList}`;
          this.errorService.openErrorSnackBarWithCustomMessage(message);
        break;
        case ErrorsEnum.TENANT_PIGEONHOLE:
          const pigeonPositions = e.error.data || [];
          const pigeonList = pigeonPositions.map(pos => pos.alias ? pos.alias : `Coordenada: ${toExcelFormat(pos.x, pos.y)}`).join(', ');
          const pigeonMsg = `Para desabilitar as posições do tipo Escaninho, esvazie as seguintes posições e tente novamente: ${pigeonList}`;
          this.errorService.openErrorSnackBarWithCustomMessage(pigeonMsg);
        break;
      }
    }

  }

  async toSetup(){
    await this.router.navigate(['/setup']);
  }

}
